<netz-page-heading size="xl">Tasks</netz-page-heading>

<govuk-tabs [queryParamsHandling]="'replace'">
  @if (role() !== 'OPERATOR') {
    <ng-template govukTabLazy id="assigned-to-me" label="Assigned to me">
      <cca-assigned-to-me />
    </ng-template>
  }

  <ng-template govukTabLazy id="assigned-to-others" label="Assigned to others">
    <cca-assigned-to-others />
  </ng-template>

  <ng-template govukTabLazy id="unassigned" label="Unassigned">
    <cca-unassigned />
  </ng-template>
</govuk-tabs>
